var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('config-cycle',{attrs:{"billing-cycle":_vm.billingCycle,"billing-cycle-list":_vm.billingCycleList,"unit":_vm.planUnitMap.user},on:{"switchCycleAction":_vm.handleBillingCycleChange,"syncCycle":_vm.syncCycle}})}
var staticRenderFns = []

export { render, staticRenderFns }